var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"index-wrap"},[_c('van-nav-bar',{attrs:{"title":"确认订单","left-arrow":""},on:{"click-left":function($event){return _vm.$router.back();}}}),_c('view-body')],1)}
var staticRenderFns = []

export { render, staticRenderFns }